<template>
  <div>
    <b-overlay :show="processing" rounded="sm" class="overlay-display">
      <template #overlay>
        <div class="text-center">
          <b-spinner type="grow" variant="info" label="Loading..."></b-spinner>
          <p id="cancel-label">Please wait...</p>
        </div>
      </template>

      <h2><strong>Manage Maintenance Site</strong></h2>
      <div class="flex" style="margin-top: 1rem;">
        <b-button
          style="margin-right: 0.5rem;"
          type="submit"
          variant="danger"
          class="form-submit-button submit-button"
          @click="deployMaintenanceSite"
          :disabled="!isApproved"
          >Deploy Maintenance Site</b-button
        >
        <b-button
          style="margin-left: 0.5rem;"
          type="submit"
          variant="success"
          class="form-submit-button submit-button"
          :disabled="!isApproved"
          @click="deployCalliaSite"
          >Deploy Callia Site</b-button
        >
      </div>
    </b-overlay>
  </div>
</template>

<script>
const ENDPOINT = process.env.VUE_APP_API_ADMIN_API_ENDPOINT;
const APPROVED_EMAILS = [
  "jaclyn@calliaflowers.com",
  "chrishane@calliaflowers.com",
  "caitlyn@calliaflowers.com",
  "eli@calliaflowers.com"
];

export default {
  data() {
    return {
      show: true,
      processing: false,
      resultMessage: ""
    };
  },
  computed: {
    isApproved() {
      return APPROVED_EMAILS.includes(
        this.$store.getters.currentUser.email.toLowerCase()
      );
    }
  },
  methods: {
    async deployMaintenanceSite(event) {
      if (!this.isApproved) {
        this.resultMessage =
          "Error: You do not have permission to perform this action.";
        return;
      }
      this.processing = true;
      event.preventDefault();
      const body = JSON.stringify({
        email: this.$store.getters.currentUser.email.toLowerCase(),
        takeDownSite: true
      });
      await this.axios
        .post(ENDPOINT + "/website/update-maintenance-status", body, {
          headers: {
            "x-api-key": "qIaQZ7nSzt8takE2wP7MY4GxE8NSTaHB4Gj2b3xW",
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        })
        .then(async response => {
          if (response.status === 200) {
            this.resultMessage = "Success: Maintenance site deployed.";
          }
        })
        .catch(error => {
          this.resultMessage = "Error: Failed to deploy maintenance site.";
          this.processing = false;
        });
      this.processing = false;
      this.onReset();
    },
    async deployCalliaSite(event) {
      if (!this.isApproved) {
        this.resultMessage =
          "Error: You do not have permission to perform this action.";
        return;
      }
      this.processing = true;
      event.preventDefault();
      const body = JSON.stringify({
        email: this.$store.getters.currentUser.email.toLowerCase(),
        takeDownSite: false
      });
      await this.axios
        .post(ENDPOINT + "/website/update-maintenance-status", body, {
          headers: {
            "x-api-key": "qIaQZ7nSzt8takE2wP7MY4GxE8NSTaHB4Gj2b3xW",
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        })
        .then(async response => {
          if (response.status === 200) {
            this.resultMessage = "Success: Callia site deployed.";
          }
        })
        .catch(error => {
          this.resultMessage = "Error: Failed to deploy Callia site.";
          this.processing = false;
        });
      this.processing = false;
      this.onReset();
    },
    onReset(event) {
      if (event) {
        event.preventDefault();
      }
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>
